<script lang="ts">
import { defineComponent } from 'vue'
export default defineComponent({
  name: 'Rule',
})
</script>
<template>
  <a-card title="角色">
    <a-table :dataSource="dataSource" :pagination="false"
    :loading="loading" :columns="columns" @change="pageChange" >
    <template #bodyCell="{ column, record,index }">
      <template v-if="column.key === 'operation'">
        <a-button-group>
            <a-button v-if="pageRule.edit>0" size="small" type="primary" @click="onEdit(record,index)">
                <EditOutlined /> 权限
            </a-button>
          </a-button-group>
      </template>
    </template>
    </a-table>
    <a-drawer
    width="40%"
    v-model:open="open"
    class="custom-class"
    root-class-name="root-class-name"
    :root-style="{ color: 'blue' }"
    style="color: red"
    title="权限设置"
    placement="right"
  >
    <rulemenu :usertype="usertype"></rulemenu>
  </a-drawer>
  </a-card>
</template>
<script setup lang="ts" name="Rule">
import api from '@/utils/http/service'
import {onMounted,defineProps,ref,watch,reactive,createVNode,defineComponent} from 'vue'
import { PlusOutlined,EditOutlined,DeleteOutlined } from '@ant-design/icons-vue'
import type {PageData} from '@/types/global'
import { useRoute } from 'vue-router'
import {DefaultRule} from '@/router/types'
import rulemenu from './rulemenu.vue'
  onMounted(()=>{
    getList()
    if(useRoute().meta.rule){
      pageRule.value=useRoute().meta.rule
    }
  })
  const open=ref<boolean>(false)
  const usertype=ref('')
  const pageRule=ref<any>(DefaultRule())
  const columns=[
    {
      title: '名称',
      dataIndex: 'text',key:'text'
    },
    {
      title: '标识',
      dataIndex: 'data',key:'data'
    },
    {
    title: '操作',
    key: 'operation',
    fixed: 'right',
    width: 100,
  },
  ]
  const page=ref<PageData>({
    current:1,
    pageSize:10,
    pageFlag:false,
    total:0,
    pageStatus:'more',
    currentKey: 'pageIndex',
    pageSizeKey: 'pageSize',
  })
  const loading=ref<boolean>(false)
  const dataSource=ref<Array<any>>([])
  const getList=():void=>{
    loading.value=true
      api.role.list({pageIndex:page.value.current,pageSize:page.value.pageSize,pageFlag:page.value.pageFlag}).then(res => {
        loading.value=false
        dataSource.value=res.data
        page.value.total=res.data.length
      })
  }
  const pageChange=(e:anly)=>{
    page.value=e
    getList()
  }
  const onAdd=(item:any,i:any):void=>{

  }
  const onEdit=(item:any,i:any):void=>{
    usertype.value=item.data
    open.value=true
  }

</script>
